<div class="tw:max-w-150 dialog-wrapper" cfDialogContent cf-loader-container position="bottom">
  <button cfDialogDismiss class="tw:absolute tw:top-4 tw:right-4">
    <svg cfIcon="close" class="tw:cursor-pointer tw:text-gray-70"></svg>
  </button>

  <div cfDialogTitle class="tw:text-3xl">{{ "events.reject_booking" | translate }}</div>

  <div class="tw:mt-4">
    <div class="tw:mb-1">{{ "events.tentative_reason_label" | translate }}</div>

    <!-- Rejection Reason -->
    <cf-form-field>
      <textarea
        cf-input
        [formControl]="reasonControl"
        rows="5"
        placeholder="{{ 'events.reason_for_rejecting_optional' | translate }}"
      ></textarea>
      <cf-input-error [error]="reasonControl.errors"> {{ "reason" | translate }} </cf-input-error>
    </cf-form-field>
  </div>

  <!-- Action Buttons -->
  <div cfDialogButtons class="tw:mt-8">
    <button cfButton variant="secondary" (click)="ref.dismiss()">{{ "cancel" | translate }}</button>
    <button cfButton variant="warning" (click)="rejectTentative()">{{ "confirm" | translate }}</button>
  </div>
</div>
